(function () {
  function initPopup(popup) {
    var productFormId = popup.getAttribute('data-product-form-id');
    if (!productFormId) return;

    var input = popup.querySelector('[data-engraving-input]');
    var saveBtn = popup.querySelector('[data-engraving-save]');

    function updateSaveState() {
      var val = input && input.value ? input.value.trim() : '';
      if (saveBtn) saveBtn.disabled = val.length === 0;
    }

    if (input) {
      input.addEventListener('input', updateSaveState);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (saveBtn && !saveBtn.disabled) saveBtn.click();
        }
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var val = input && input.value ? input.value.trim() : '';
        if (!val) return;

        var form = document.getElementById(productFormId);
        var textInput = form && form.querySelector('[data-engraving-text-input]');
        if (textInput) textInput.value = val;

        var productFormComponent = form && form.closest('product-form-component');
        if (productFormComponent) {
          productFormComponent.dataset.engravingText = val;
          var pid = productFormComponent.dataset.productId;
          if (pid && typeof sessionStorage !== 'undefined') {
            try {
              sessionStorage.setItem('engraving_text_' + pid, val);
            } catch (err) {
              console.error('Failed to set engraving text in session storage:', err);
            }
          }
        }

        var trigger = document.querySelector('[data-engraving-trigger]');
        if (trigger) {
          trigger.classList.remove('custom-dropdown--unselected');
          trigger.classList.add('custom-dropdown--selected');
        }

        if (input) input.value = val;
        if (typeof popup.closeDialog === 'function') {
          popup.closeDialog();
        } else {
          var dialogEl = popup.querySelector('dialog');
          if (dialogEl && typeof dialogEl.close === 'function') dialogEl.close();
        }
      });
    }

    popup.addEventListener('dialog:open', function () {
      var form = document.getElementById(productFormId);
      var textInput = form && form.querySelector('[data-engraving-text-input]');
      var productFormComponent = form && form.closest('product-form-component');
      var pid = productFormComponent && productFormComponent.dataset.productId;
      var fromForm = textInput && textInput.value ? textInput.value : '';
      var fromComponent =
        productFormComponent && productFormComponent.dataset.engravingText
          ? productFormComponent.dataset.engravingText
          : '';
      var fromStorage =
        pid && typeof sessionStorage !== 'undefined'
          ? sessionStorage.getItem('engraving_text_' + pid) || ''
          : '';
      var fromInput = input && input.value ? input.value : '';
      var currentVal = fromForm || fromComponent || fromStorage || fromInput;

      function applyValue() {
        if (input) {
          input.value = currentVal;
          input.focus();
        }
        updateSaveState();
      }
      applyValue();
      setTimeout(applyValue, 0);
    });
  }

  document.querySelectorAll('.engraving-drawer[data-product-form-id]').forEach(initPopup);
})();
